// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"234":"40c598b8","252":"927363f3","278":"6dceb0b9"}[chunkId] + ".chunk.css";
};